export const IP_ORGANISMOS_ACTIONS_TYPES = {
  SET_TABLE_DATA: 'SET_TABLE_DATA',
  SET_LOADING: 'SET_LOADING',
  SET_FAILURE: 'SET_FAILURE',
  SET_TABLE_SELECTION: 'SET_TABLE_SELECTION',
  SET_IP: 'SET_IP',
  SET_FORM_STATE: 'SET_FORM_STATE',
  SET_DETAIL_LOADING: 'SET_DETAIL_LOADING',
  SET_DETAIL_FAILURE: 'SET_DETAIL_FAILURE',
  SET_IP_EVENTS: 'SET_IP_EVENTS',
}

export const IP_ORGANISMOS_INITIAL_STATE = {
  data: [],
  search: {},
  pagination: {},
  loading: false,
  detailLoading: false,
  detailError: false,
  msLoaded: false,
  error: false,
  tableSelection: [],
  ip: {},
  formState: {},
  events: [],
}
